import * as React from "react";
import { Link } from "gatsby";
// import PropTypes from "prop-types";

// import Mainnav from "./mainNav";

import * as styles from "./footer.module.css";
// import { Link } from "gatsby";

const Footer = ({ menuLinks }) => (
  <footer className={styles.footer}>
    <div className={styles.footer_wrapper}>
      <ul className={styles.footer_menu}>
        <li>
          <Link to={"/privacy/"}>Privacy</Link>
        </li>
        <li>
          <Link to={"/terms/"}>Terms</Link>
        </li>
        <li>
          <Link to={"/safety-tips/"}>Safety</Link>
        </li>
        <li>
          <Link to={"/community-guidelines/"}>Community</Link>
        </li>
        <li>
          <Link to={"/feedback/"}>feedback</Link>
        </li>
        <li>
          <Link to={"/contact-us/"}>Contact</Link>
        </li>
      </ul>
      <p>&#169; Mabrosi Inc. 2024, All Rights Reserved.</p>
    </div>
  </footer>
);

// Header.propTypes = {
//   siteTitle: PropTypes.string,
//   siteDescription: PropTypes.string,
//   menuLinks: PropTypes.array,
// };

Footer.defaultProps = {
  // siteTitle: ``,
  // siteDescription: ``,
  menuLinks: [],
};

export default Footer;
